// extracted by mini-css-extract-plugin
export var downArrow = "_aj-0";
export var label = "_aj-1";
export var treatmentCard = "_aj-3";
export var upArrow = "_aj-2";